import LegalLayout from "./LegalLayout";

export default function RefundPolicy() {
  return (
    <LegalLayout
      testId="refund-policy-page"
      eyebrow="Legal"
      title="Cancellation & Refund Policy"
      updated="February 2026"
    >
      <section>
        <h2>1. Overview</h2>
        <p>
          We understand travel plans change. Our cancellation policy is designed to be fair to
          our clients while covering the real operational costs of allocating a vehicle,
          scheduling a professional driver, and pre-purchasing any add-ons requested for your
          transfer.
        </p>
      </section>

      <section>
        <h2>2. Cancellation Windows</h2>
        <ul>
          <li>
            <strong>More than 24 hours before the scheduled pickup time:</strong> the deposit is
            fully refundable. Refunds are processed within 5–10 business days to the original
            payment method.
          </li>
          <li>
            <strong>Within 24 hours of the scheduled pickup time:</strong> the booking is
            <strong> non-refundable</strong>. This covers operational costs, vehicle
            allocation, driver dispatch, and any pre-purchased add-ons such as snacks, drinks,
            and 5G SIM cards.
          </li>
          <li>
            <strong>No-shows</strong> (client fails to appear at the pickup location and does not
            respond to driver contact within the free waiting window) are treated as
            same-day cancellations and are non-refundable.
          </li>
        </ul>
      </section>

      <section>
        <h2>3. How to Cancel</h2>
        <p>
          To cancel a booking, reply to your original booking confirmation email at{" "}
          <a href="mailto:bookings@juketransfers.hr" className="text-[#C5A059] hover:text-[#D4AF37] underline underline-offset-2">bookings@juketransfers.hr</a>
          {" "}or send us a message on WhatsApp at{" "}
          <a href="https://wa.me/385989344079" className="text-[#C5A059] hover:text-[#D4AF37] underline underline-offset-2">+385 98 934 4079</a>
          {" "}with your booking reference. The cancellation timestamp is the moment we receive
          your written message.
        </p>
      </section>

      <section>
        <h2>4. Rescheduling</h2>
        <p>
          We are happy to reschedule your transfer to a different date or time, subject to
          availability. If the reschedule request is made more than 24 hours before pickup, no
          fee applies. Reschedules made within 24 hours may incur a re-dispatch fee at our
          discretion.
        </p>
      </section>

      <section>
        <h2>5. Cancellations Caused by Us</h2>
        <p>
          If we are unable to fulfil your booking due to circumstances on our side (vehicle
          breakdown without a suitable replacement, unavoidable driver unavailability), you will
          receive a <strong>full refund</strong> and, where possible, we will arrange an
          equivalent partner vehicle at no additional cost.
        </p>
      </section>

      <section>
        <h2>6. Force Majeure</h2>
        <p>
          In the case of events beyond our reasonable control — extreme weather, road closures,
          government restrictions, industrial action, or airport shutdowns — we will contact you
          promptly to reschedule or refund on a case-by-case basis. No penalty will be applied to
          the client in such circumstances.
        </p>
      </section>

      <section>
        <h2>7. Add-ons & Pre-purchased Items</h2>
        <p>
          Add-ons such as chilled beverages, snack boxes, and tourist 5G SIM cards are purchased
          and prepared in advance for your specific booking. Once a booking enters the 24-hour
          non-refundable window, these items cannot be refunded independently of the transfer
          fee.
        </p>
      </section>

      <section>
        <h2>8. Contact</h2>
        <p>
          For any refund questions or disputes, please contact{" "}
          <a href="mailto:bookings@juketransfers.hr" className="text-[#C5A059] hover:text-[#D4AF37] underline underline-offset-2">bookings@juketransfers.hr</a>.
          We aim to reply within 24 hours.
        </p>
      </section>
    </LegalLayout>
  );
}
